import type { Router } from 'vue-router'

import { usePermissionStoreWithOut } from '@admin/store/modules/permission'

import { useUserStoreWithOut } from '@admin/store/modules/user'
import { useSiteStoreWithOut } from '@admin/store/modules/site'

export function createPermissionGuard(router: Router) {
  const userStore = useUserStoreWithOut()
  const permissionStore = usePermissionStoreWithOut()
  const siteStore = useSiteStoreWithOut()

  router.beforeEach(async (to, from, next) => {
    if (userStore.token) {
      if (to.path === '/login') {
        next('/')
      } else {
        if (!permissionStore.menuList.length) {
          await Promise.all([
            permissionStore.getMenuList(),
            siteStore.getSites(),
            siteStore.getCurrencyOptions(),
          ])
        }
        next()
      }
    } else {
      if (to.path === '/login') {
        next()
      } else {
        next(`/login?redirect=${to.fullPath}`)
      }
    }
  })
}
